// Module
var code = "<div class=\"vt-sidenav__footer\" data-ng-style=\"{ bottom: vsf.bottom() }\">\n    <md-button class=\"vt-sidenav__footer-btn md-primary md-raised md-button-uppercase\" ng-click=\"vsf.save()\">Save\n        changes\n    </md-button>\n</div>";
// Exports
var _module_exports = code;;
var path = 'template/component/widget/sidenav/vt-sidenav-footer.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;